import { useEffect, useState } from 'react';
import { Alert, Button, Spinner, useClipboard } from '@chakra-ui/react';
import { FiCheck, FiCopy } from 'react-icons/fi';

import { api } from '@app/api';
import { Equipment } from '@app/api/models/equipment';

export const CopyValue = ({ value, label }: { value: string; label: string }) => {
  const { onCopy, hasCopied } = useClipboard(value);
  return <button type="button" className="request-copy" onClick={onCopy} aria-label={hasCopied ? 'Скопировано' : label} title={hasCopied ? 'Скопировано' : label}>
    {hasCopied ? <FiCheck size={14} /> : <FiCopy size={14} />}
  </button>;
};

export const RequestEquipment = ({ outletId }: { outletId: number }) => {
  const [items, setItems] = useState<Equipment[]>([]);
  const [total, setTotal] = useState<number>();
  const [offset, setOffset] = useState(0);
  const [revision, setRevision] = useState(0);
  const [loading, setLoading] = useState(true);
  const [failure, setFailure] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setFailure(false);
    void (async () => {
      try {
        const { data } = await api.equipments.getEquipmentsOutlet(outletId, { limit: 50, offset, sort: '+id', filter: {} });
        if (data.code !== 200) { throw new Error(data.message); }
        if (active) {
          setItems((previous) => offset ? [...previous, ...data.data.data] : data.data.data);
          setTotal(data.data.total);
        }
      } catch {
        if (active) { setFailure(true); }
      } finally {
        if (active) { setLoading(false); }
      }
    })();
    return () => { active = false; };
  }, [outletId, offset, revision]);
  return <aside className="request-panel request-equipment" aria-label="Оборудование в точке">
    <h2 className="request-section-title">Оборудование в точке{total !== undefined ? ` · ${total}` : ''}</h2>
    {items.map((item) => <article className="request-equipment-item" key={item.id}>
      <div className="request-equipment-heading"><h3 className="request-equipment-name">{item.model?.name || 'Модель не указана'}</h3>
      {typeof item.is_efficient === 'boolean' ? <label className="request-equipment-efficiency"><input type="checkbox" checked={item.is_efficient} disabled />Эффективность ХО</label> : <span className="request-equipment-efficiency">Эффективность ХО: <strong>Нет данных</strong></span>}
      </div>
      {[['Инв. №', item.inventory_num], ['Серийный №', item.serial_num]].map(([label, value]) => <div className="request-equipment-number" key={label}>
        <span>{label}</span><code>{value || '—'}</code>{value && <CopyValue value={value} label={`Скопировать ${label} ${value}`} />}
      </div>)}
    </article>)}
    {loading && <Spinner size="sm" aria-label="Загрузка оборудования" />}
    {failure && <><Alert status="error" fontSize="sm">Не удалось загрузить ХО</Alert><Button mt={3} size="sm" onClick={() => setRevision((value) => value + 1)}>Повторить</Button></>}
    {!loading && !failure && total === 0 && <p className="request-note">Оборудование не найдено</p>}
    {!loading && !failure && items.length < total && <Button size="sm" mt={3} onClick={() => setOffset(items.length)}>Показать ещё</Button>}
  </aside>;
};
